module.exports = __webpack_public_path__ + "static/media/glanum_keltisch_tn.b00c7884.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_keltisch_tn.jpg
// module id = 716
// module chunks = 0